import {Component, Input, OnInit} from '@angular/core';
import {FormControl, Validators} from "@angular/forms";

@Component({
  selector: 'cat-input-icon-pos',
  templateUrl: './input-icon-pos.component.html',
  styleUrls: ['./input-icon-pos.component.scss']
})
export class InputIconPosComponent implements OnInit {

  @Input() iconPosXFormArrayName;
  @Input() iconPosYFormArrayName;
  @Input() roleFormArrayName;
  @Input() parentForm;
  @Input() label;
  @Input() defaultValueLabel;

  roleOptions = [
    { label: 'All', value: 'all' },
    { label: 'Audio', value: 'audio' },
    { label: 'Video', value: 'video' },
  ];

  constructor() { }

  ngOnInit() {
  }

  addItem() {
    this.iconPosXFormArray().push(new FormControl(0, [Validators.required]));
    this.iconPosYFormArray().push(new FormControl(0, [Validators.required]));
    this.roleFormArray().push(new FormControl('all', [Validators.required]));
    this.iconPosXFormArray().markAsDirty();
    this.iconPosYFormArray().markAsDirty();
    this.roleFormArray().markAsDirty();
  }

  removeItem(index) {
    this.iconPosXFormArray().removeAt(index);
    this.iconPosYFormArray().removeAt(index);
    this.roleFormArray().removeAt(index);
    this.iconPosXFormArray().markAsDirty();
    this.iconPosYFormArray().markAsDirty();
    this.roleFormArray().markAsDirty();
  }

  private iconPosXFormArray() {
    return this.parentForm.get(this.iconPosXFormArrayName);
  }

  private iconPosYFormArray() {
    return this.parentForm.get(this.iconPosYFormArrayName);
  }

  private roleFormArray() {
    return this.parentForm.get(this.roleFormArrayName);
  }

  roleFormArrayControls() {
    if (this.parentForm
        && this.parentForm.get(this.roleFormArrayName)
        && this.parentForm.get(this.roleFormArrayName).controls) {
      return this.parentForm.get(this.roleFormArrayName).controls;
    } else {
      return [];
    }
  }

  showDefaultValue() {
    return this.defaultValueLabel
      && this.defaultValueLabel !== '';
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/ggw-device/components/input-icon-pos/input-icon-pos.component.ts